export default "__VITE_ASSET__CKEsZ0v$__"